<template>
  <div id="profile_modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-3">
              <form action="#" role="form" enctype="multipart/form-data">
                <div class="portlet light avatar-box">
                  <div class="portlet-title tabbable-line">
                    <div class="caption caption-md">
                      <i class="icon-globe theme-font hide"></i>
                      <span class="caption-subject bold uppercase">{{ fullName }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="fileinput fileinput-new" data-provides="fileinput">
                    <div class="fileinput-new thumbnail">
                      <!--<img v-bind:src="avatar" alt=""-->
                      <!--style="width:100%;">-->
                      <avatar v-bind:username="name" v-bind:src="avatar" :size="140" :rounded="true" color="#d09f23"
                              backgroundColor="#eef1f5"></avatar>
                    </div>
                  </div>
                  <span class="btn default btn-file" v-if="false">
                    <span class="fileinput-exists"> Upload Avatar </span>
                    <input type="hidden" value="" name="..."><input type="file" name="avatar" id="avatar"
                                                                    accept="image/*" @change="updateAvatar">
                  </span>

                  <a class="btn green" @click="toggleShow">Upload Image</a>
                  <my-upload field="img"
                             @crop-success="cropSuccess"
                             @crop-upload-success="cropUploadSuccess"
                             @crop-upload-fail="cropUploadFail"
                             v-model="show"
                             :noRotate="false"
                             :width="300"
                             :height="300"
                             lang-type="en"
                             :params="params"
                             :headers="headers"
                             img-format="png"></my-upload>
                  <button class="btn default" @click.prevent="updateAvatarBase(null)">Remove</button>

                </div>
              </form>
            </div>
            <div class="col-md-9">
              <div class="portlet light">
                <div class="portlet-title tabbable-line">
                  <div class="caption caption-md">
                    <i class="icon-globe theme-font hide"></i>
                    <span class="caption-subject bold uppercase">Profile Account</span>
                  </div>
                  <ul class="nav nav-tabs">
                    <li class="active">
                      <a href="#tab_1_1" data-toggle="tab" aria-expanded="true">My Profile</a>
                    </li>
                    <li class="">
                      <a href="#tab_1_3" data-toggle="tab" aria-expanded="false">Change Password</a>
                    </li>
                  </ul>
                </div>
                <div class="portlet-body">
                  <div class="tab-content">
                    <!-- PERSONAL INFO TAB -->
                    <div class="tab-pane active" id="tab_1_1">
                      <form role="form" data-vv-scope="profile-form" action="#">
                        <div class="form-group" :class="{ 'has-error': errors.has('profile-form.Full Name') }">
                          <label class="control-label">Full Name</label>
                          <input type="text" placeholder="" class="form-control" name="Full Name" v-model="fullName"
                                 v-validate="'required'">
                          <span v-show="errors.has('profile-form.Full Name')" class="help-block">{{ errors.first('profile-form.Full Name') }}</span>
                        </div>
                        <div class="form-group">
                          <label class="control-label">Email Address</label>
                          <input type="text" placeholder="" class="form-control" v-model="email" disabled>
                        </div>
                        <div class="form-group" :class="{ 'has-error': errors.has('profile-form.Job Title') }">
                          <label class="control-label">Job Title</label>
                          <input type="text" placeholder="" class="form-control" name="Job Title" v-model="jobTitle"
                                 v-validate="'required'">
                          <span v-show="errors.has('profile-form.Job Title')" class="help-block">{{ errors.first('profile-form.Job Title') }}</span>
                        </div>
                        <div class="form-group" :class="{ 'has-error': errors.has('profile-form.Primary Phone') }">
                          <label class="control-label">Primary Phone</label>
                          <input type="text" placeholder="" class="form-control" name="Primary Phone"
                                 v-model="primaryPhone" v-validate="'required'">
                          <span v-show="errors.has('profile-form.Primary Phone')" class="help-block">{{ errors.first('profile-form.Primary Phone') }}</span>
                        </div>
                        <div class="alert alert-dismissable" v-show="showAlertUserData" v-bind:class="alertType">
                          <strong>{{ alertMessagePre }}</strong> {{ alertMessage }}
                        </div>
                        <div class="margiv-top-10">
                          <button class="btn green mt-ladda-btn ladda-button updateInfoAction" data-style="expand-left"
                                  @click.prevent="updateUserInfo">
                            <span class="ladda-label">Save Changes</span>
                          </button>
                          <button type="button" data-dismiss="modal" aria-hidden="true" class="btn default"> Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <!-- END PERSONAL INFO TAB -->
                    <!-- CHANGE PASSWORD TAB -->
                    <div class="tab-pane" id="tab_1_3">
                      <form action="#" data-vv-scope="password-form" @submit.prevent="changePassword">
                        <div class="form-group" :class="{ 'has-error': errors.has('password-form.current password') }">
                          <label class="control-label">Current Password</label>
                          <input type="password" class="form-control" name="current password" v-model="currentPassword"
                                 v-validate="'required'" :class="{'input': true }">
                          <span v-show="errors.has('password-form.current password')" class="help-block">{{ errors.first('password-form.current password') }}</span>
                        </div>
                        <div class="form-group" :class="{ 'has-error': errors.has('password-form.new password') }">
                          <label class="control-label">New Password</label>
                          <input type="password" class="form-control" v-model="newPassword" id="newPass"
                                 name="new password" v-validate="{required:true, min:6, max:16, password: true}" :class="{'input': true }">
                          <span v-show="errors.has('password-form.new password')" class="help-block">{{ errors.first('password-form.new password') }}</span>
                        </div>
                        <div class="form-group"
                             :class="{ 'has-error': errors.has('password-form.confirm new password') }">
                          <label class="control-label">Confirm New Password</label>
                          <input type="password" class="form-control" v-model="confirmNewPassword"
                                 name="confirm new password" v-validate="{required: true, is: newPassword}"
                                 :class="{'input': true }"
                                 ref="new password"
                          >
                          <span v-show="errors.has('password-form.confirm new password')" class="help-block">{{ errors.first('password-form.confirm new password') }}</span>
                        </div>
                        <div class="alert alert-dismissable" v-show="showAlertPassword" v-bind:class="alertType">
                          <strong>{{ alertMessagePre }}</strong> {{ alertMessage }}
                        </div>

                        <div class="margin-top-10">
                          <button class="btn green mt-ladda-btn ladda-button changePasswordAction"
                                  data-style="expand-left" type="submit">
                            <span class="ladda-label">Change Password</span>
                          </button>
                          <button type="button" data-dismiss="modal" aria-hidden="true" class="btn default"> Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <!-- END CHANGE PASSWORD TAB -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {HTTP, ERROR, getUserInfo, updateUserInfo, URL} from '@/http-common.js';
  import myUpload from 'vue-image-crop-upload';
  import {mapGetters, mapActions} from 'vuex';
  import Avatar from '@/components/menu/Avatar';
  export default {
    data() {
      return {
        name: getUserInfo('first_name'),
        fullName: getUserInfo('first_name') + ' ' + getUserInfo('last_name'),
        email: getUserInfo('email'),
        jobTitle: getUserInfo('job_title'),
        primaryPhone: getUserInfo('phone_number'),
        avatar: getUserInfo('avatar') ? getUserInfo('avatar') : undefined,
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        alertMessage: '',
        alertMessagePre: '',
        alertType: '',
        showAlertUserData: false,
        showAlertPassword: false,
        show: false,
        imgDataUrl: '',
        params: {
          token: '123456798',
          name: 'avatar'
        },
        headers: {
          smail: '*_~'
        }
      }
    },
    inject: {
      $validator: '$validator'
    },
    components: {
      Avatar,
      'my-upload': myUpload,
    },
    computed: {
      ...mapGetters([
        'getUser'
      ]),
      user: function () {
        return this.getUser;
      }
    },
    methods: {
      ...mapActions([
        'setUserValue'
      ]),
      bindEvents() {
        var self = this;
        $('#profile_modal').on('hidden.bs.modal', function () {
          self.clearForm();
        });
        $('#profile_modal').on('show.bs.modal', function () {
          self.clearForm();
        })
      },
      clearForm() {
        this.showAlertPassword = false;
        this.showAlertUserData = false;
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.errors.clear('password-form')
      },
      toggleShow() {
        this.show = !this.show;
      },
      cropSuccess(imgDataUrl, field){
        this.imgDataUrl = imgDataUrl;
        this.updateAvatarBase(imgDataUrl);
      },
      cropUploadSuccess(jsonData, field){
        console.log(jsonData);
        console.log('field: ' + field);
      },
      cropUploadFail(status, field){
        console.log(status);
        console.log('field: ' + field);
      },
      updateUserInfo() {
        this.$validator.validateAll('profile-form').then((result) => {
          if (result) {
            this.button = Ladda.create(document.querySelector('.updateInfoAction'));
            this.button.start();
            this.showAlertPassword = false;
            HTTP.post(`users/profile/edit`, {
              job_title: this.jobTitle,
              full_name: this.fullName,
              phone_number: this.primaryPhone
            })
              .then(response => {
                ERROR(response);
                if (response.data.status = 'success') {
                  this.displayAlert(response, 'UserData');
                  this.setUserValue({
                    'first_name': this.getName(this.fullName),
                    'last_name': this.getLastName(this.fullName),
                    'phone_number': this.primaryPhone,
                    'job_title': this.jobTitle
                  });
                  updateUserInfo('job_title', this.jobTitle);
                  updateUserInfo('phone_number', this.primaryPhone);
                  updateUserInfo('first_name', this.getName(this.fullName));
                  updateUserInfo('last_name', this.getLastName(this.fullName));
                }
                this.button.stop();
              }).catch(err => {
              console.log(err);
            })
          }
        });
      },
      getName(str) {
        var arr = str.split(' ');
        if (arr.length === 1) {
          return arr[0];
        }
        return arr.slice(0, -1).join(' ');
      },
      getLastName(str) {
        var arr = str.split(' ');
        if (arr.length === 1) {
          return "";
        }
        return arr.slice(-1).join(' ');
      },
      updateAvatar(e) {
        var files = e.target.files || e.dataTransfer.files;
        var data = new FormData();
        if (!files.length)
          return;
        data.append('file', files[0]);
        HTTP.post(`users/avatar`, data)
          .then(response => {
            ERROR(response);
            if (response.data.status == 'success') {
              this.avatar = response.data.data.name;
              updateUserInfo('avatar', response.data.data.name);
              this.$notify('Profile image updated.');
              this.$emit('avatarUpdate', true);
            }
          }).catch(err => {
          console.log(err);
        })
      },
      updateAvatarBase(file) {
        HTTP.post(`users/avatar`, {file})
          .then(response => {
            ERROR(response);
            if (response.data.status == 'success') {
              this.avatar = response.data.data.name;
              updateUserInfo('avatar', response.data.data.name);
              this.setUserValue({'avatar': response.data.data.name});
              this.$notify('Profile image updated.');
              this.$emit('avatarUpdate', true);
            }
          }).catch(err => {
          console.log(err);
        })
      },
      changePassword(){
        this.$validator.validateAll('password-form').then((result) => {
          if (result) {
            this.buttonPassword = Ladda.create(document.querySelector('.changePasswordAction'));
            this.buttonPassword.start();
            this.showAlertPassword = false;
            HTTP.post(`users/profile/password`, {
              password: this.currentPassword,
              new_password: this.newPassword
            })
              .then(response => {
                ERROR(response);
                this.displayAlert(response, 'Password');
                this.buttonPassword.stop();
              }).catch(err => {
              console.log(err);
            })
          }
        });
      },
      displayAlert(response, target) {
        this.showAlertUserData = false;
        this.showAlertPassword = false;
        if (response.data.status == 'success') {
          this.alertMessage = response.data.data[0];
          this.alertMessagePre = 'Success!';
          this.alertType = 'alert-success';
          this.errors.clear();
        } else {
          this.alertMessage = response.data.message;
          this.alertMessagePre = '';
          this.alertType = 'alert-danger';
        }
        if (target == 'UserData') {
          this.showAlertUserData = true;
        } else {
          this.showAlertPassword = true;
        }
      }
    },
    mounted() {
      this.bindEvents();
    }
  }
</script>
<style scoped>
  .portlet.light {
    padding: 0px;
  }

  .avatar-box .portlet-title {
    min-height: 49px;
  }

  @media (min-width: 768px) {
    .mt-radio-inline {
      min-width: 130px;
    }
  }
</style>



// WEBPACK FOOTER //
// MyProfile.vue?52776b0c